'use client';

import Link from 'next/link';
import { BookCover, type CoverTreatment } from './book-cover';
import type { Book } from '@/types/catalog';

type Variant = 'carousel' | 'grid' | 'list';

interface BookCardProps {
  book: Book;
  variant?: Variant;
  width?: number;
  isNew?: boolean;
  treatment?: CoverTreatment;
}

export function BookCard({ book, variant = 'carousel', width = 168, isNew = false, treatment = 'shadow' }: BookCardProps) {
  const href = `/libro/${book.id}`;

  if (variant === 'list') {
    return (
      <Link
        href={href}
        style={{
          display: 'grid',
          gridTemplateColumns: '96px 1fr',
          gap: 20,
          padding: '20px 0',
          borderBottom: '1px solid var(--rule)',
          textDecoration: 'none',
          color: 'inherit',
        }}
      >
        <BookCover book={book} w={96} treatment={treatment} />
        <div>
          <div className="serif" style={{ fontSize: 22, lineHeight: 1.2 }}>{book.title}</div>
          <div style={{ color: 'var(--stone)', marginTop: 4, fontSize: 14 }}>{book.author}{book.year ? ` · ${book.year}` : ''}</div>
          <div style={{ marginTop: 10, color: 'var(--ink-soft)', fontSize: 14, maxWidth: 620, textWrap: 'pretty' }}>
            Edición digital con notas y guía de lectura. Disponible para préstamo de 30 días.
          </div>
          <div style={{ marginTop: 10, display: 'flex', gap: 8 }}>
            {book.subject && <span className="chip">{book.subject}</span>}
            {book.pages ? <span className="chip">{book.pages} pp.</span> : null}
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link href={href} className="book-card" style={{ display: 'block', width, textDecoration: 'none', color: 'inherit' }}>
      <div style={{ position: 'relative' }} className="book-card-cover">
        <BookCover book={book} w={width} treatment={treatment} />
        {isNew && (
          <div style={{ position: 'absolute', top: 10, left: 10 }}>
            <span className="badge-new">Nuevo</span>
          </div>
        )}
      </div>
      <div style={{ paddingTop: 14 }}>
        <div className="serif book-card-title" style={{ fontSize: 16, lineHeight: 1.25, color: 'var(--ink)' }}>{book.title}</div>
        <div style={{ color: 'var(--stone)', fontSize: 13, marginTop: 4 }}>{book.author}</div>
      </div>
      <style>{`
        .book-card:hover .book-card-cover > div { transform: translateY(-2px); }
        .book-card:hover .book-card-title { text-decoration: underline; text-underline-offset: 3px; }
      `}</style>
    </Link>
  );
}
